import { isEmbedded } from "@/utils/Utils";

interface IAppShellClient {
  refreshAuthToken: () => Promise<unknown>;
}

class AnaplanTokenRefreshService {
  private refreshInterval: NodeJS.Timeout | null = null;
  private readonly REFRESH_INTERVAL = 5 * 60 * 1000;

  start(appShellClient: IAppShellClient) {
    if (!isEmbedded()) return;
    if (this.refreshInterval) return;
    
    appShellClient.refreshAuthToken().catch(console.error);
    
    this.refreshInterval = setInterval(() => {
      appShellClient.refreshAuthToken().catch(console.error);
    }, this.REFRESH_INTERVAL);
  }

  stop() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
  }
}

export const anaplanTokenRefreshService = new AnaplanTokenRefreshService();